/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BaseAttribute
 */
export interface BaseAttribute {
    /**
     * 
     * @type {string}
     * @memberof BaseAttribute
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAttribute
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAttribute
     */
    dataTypeCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseAttribute
     */
    isVisible?: boolean;
}

export function BaseAttributeFromJSON(json: any): BaseAttribute {
    return BaseAttributeFromJSONTyped(json, false);
}

export function BaseAttributeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BaseAttribute {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
        'dataTypeCode': json['dataTypeCode'],
        'isVisible': !exists(json, 'isVisible') ? undefined : json['isVisible'],
    };
}

export function BaseAttributeToJSON(value?: BaseAttribute | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
        'dataTypeCode': value.dataTypeCode,
        'isVisible': value.isVisible,
    };
}


